import { MARKER_END2} from './MarkerEndTypes2'

const initialState = {
    markerEnd2: ""
}

const markerEndReducer2 = (state = initialState, action) => {
    
    switch (action.type) {
        case MARKER_END2:
            
            return {
                markerEnd2: action.load
            }
    
        default:
          return state
    }

}


export default markerEndReducer2;